import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { BOLD_FONT_FAMILY, ENTRY_SCENE_ALERT } from '../../constants/constants';
import { isLocalhostEnvironment } from '../../utils/utils';
const ENTRY_SCENE_ALERT_CSS = css `
  background-color: #aa0000;
  color: white;
  font-family: ${BOLD_FONT_FAMILY};
  font-size: 24px;
  padding: 20px;
  span {
    filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.2));
  }
`;
const ServerAlertSchema = z
    .object({
    msg: z.string()
})
    .nullable();
function serverAlertParser(str) {
    try {
        const parsed = JSON.parse(str);
        const valid = ServerAlertSchema.parse(parsed);
        return valid;
    }
    catch {
        // don't set bad beat jackpot on error
    }
}
async function fetchServerAlert() {
    if (ENTRY_SCENE_ALERT) {
        return ENTRY_SCENE_ALERT;
    }
    if (isLocalhostEnvironment()) {
        return false;
    }
    try {
        const response = await fetch('/api_server_alert.php');
        if (!response.ok) {
            return false;
        }
        const jsonStr = await response.text();
        const serverAlert = serverAlertParser(jsonStr);
        return serverAlert?.msg || false;
    }
    catch {
        // do nothing on error
    }
    return false;
}
export const EntrySceneAlertContainer = () => {
    const { data: alertMessage } = useQuery({ queryKey: ['entry-alert'], queryFn: fetchServerAlert });
    if (!alertMessage) {
        return null;
    }
    return (_jsx("div", { css: ENTRY_SCENE_ALERT_CSS, children: _jsx("span", { children: alertMessage }) }));
};
